import React from "react";
import { Stack } from "@mui/material";

import sichero_front from "src/shared/assets/sichero/sichero1.png";
import sichero_left from "src/shared/assets/sichero/sichero2.png";
import sichero_right from "src/shared/assets/sichero/sichero3.png";

import styles from "./AnimatedSichero.module.scss";

export const AnimatedSichero: React.FC = () => {
  return (
    <Stack
      width={1}
      height={1}
      direction="row"
      position="absolute"
      right={0}
      alignItems="center"
      justifyContent="flex-end"
      className={styles.container}
    >
      <img
        width="20%"
        src={sichero_left}
        alt="sichero"
        className={styles.image}
      />
      <img
        width="40%"
        src={sichero_front}
        alt="sichero"
        className={styles.image}
      />
      <img
        width="20%"
        src={sichero_right}
        alt="sichero"
        className={styles.image}
      />
    </Stack>
  );
};
